export { State, initialState } from './allegati.state';
export * from './allegati.actions';
export { allegatiReducer } from './allegati.reducer';